/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/315/interface/api/cat_4886
 */
import { message } from 'ant-design-vue'
import {
  service_col_filter_page_post,
  service_col_page_get,
  service_col_queryFilterInfo_get,
  service_collection_promotion_batchGet_post,
  service_collection_promotion_validList_post,
  service_col_seo_info_get,
  service_col_skc_detail_get,
  col_cache_del_get,
  col_cache_set_get,
  col_filter_page_post,
  col_page_get,
  col_queryFilterInfo_get,
  col_seo_info_get,
  col_seo_urls_get,
  col_skc_detail_get,
  col_skc_info_post
} from 'server/modules/4886' // collection分页查询, 条件和价格过滤

export const service_col_filter_page_post_ = async function(params) {
  const { success, data, retInfo } = await service_col_filter_page_post(params)

  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
} // collection分页查询, 不支持条件和价格过滤

export const service_col_page_get_ = async function(params, state) {
  const { success, data, retInfo } = await service_col_page_get(params)
  if (success) {
    let list = []
    data.dataDetail.map(item => {
      const { skcs } = item
      const { productTypeName, title, appSkcDiscountPrice, medias } = skcs[0]
      list.push({
        productTypeName,
        title,
        appSkcDiscountPrice,
        img: medias.length ? medias[0].src : ''
      })
    })
    state.list = list
    state.total = data.total
  } else {
    message.error(retInfo)
  }
} // collection筛选项

export const service_col_queryFilterInfo_get_ = async function(params, state) {
  const { success, data, retInfo } = await service_col_queryFilterInfo_get(
    params
  )

  if (success) {
    const { bannerAppImageUrl } = data
    state.banner =
      bannerAppImageUrl &&
      bannerAppImageUrl[0] &&
      bannerAppImageUrl[0].bannerUrl
        ? bannerAppImageUrl[0].bannerUrl
        : ''
  } else {
    message.error(retInfo)
  }
} // 查询Collection商品信息（促销用）

export const service_collection_promotion_batchGet_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await service_collection_promotion_batchGet_post(params)

  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
} // 分页查询Collection基础信息（促销用）

export const service_collection_promotion_validList_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await service_collection_promotion_validList_post(params)

  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
} // 自研collection seo信息

export const service_col_seo_info_get_ = async function(params) {
  const { success, data, retInfo } = await service_col_seo_info_get(params)

  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
} // 查询skc详细信息

export const service_col_skc_detail_get_ = async function(params) {
  const { success, data, retInfo } = await service_col_skc_detail_get(params)

  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
} // 模糊删除缓存key

export const col_cache_del_get_ = async function(params) {
  const { success, data, retInfo } = await col_cache_del_get(params)

  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
} // 设置缓存开关

export const col_cache_set_get_ = async function(params) {
  const { success, data, retInfo } = await col_cache_set_get(params)

  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
} // collection分页查询, 条件和价格过滤

export const col_filter_page_post_ = async function(params) {
  const { success, data, retInfo } = await col_filter_page_post(params)

  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
} // collection分页查询, 不支持条件和价格过滤

export const col_page_get_ = async function(params) {
  const { success, data, retInfo } = await col_page_get(params)

  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
} // collection筛选项

export const col_queryFilterInfo_get_ = async function(params) {
  const { success, data, retInfo } = await col_queryFilterInfo_get(params)

  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
} // 自研collection seo信息

export const col_seo_info_get_ = async function(params) {
  const { success, data, retInfo } = await col_seo_info_get(params)

  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
} // 自研collection白名单

export const col_seo_urls_get_ = async function(params) {
  const { success, data, retInfo } = await col_seo_urls_get(params)

  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
} // 查询skc详细信息

export const col_skc_detail_get_ = async function(params) {
  const { success, data, retInfo } = await col_skc_detail_get(params)

  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
} // 查询collection skc信息

export const col_skc_info_post_ = async function(params) {
  const { success, data, retInfo } = await col_skc_info_post(params)

  if (success) {
    data && message.success(retInfo)
  } else {
    message.error(retInfo)
  }
}
